var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":_vm.mpAuthUrl}},[_vm._v("Vincular cuenta de Mercado Pago.")])])}
var staticRenderFns = []

export { render, staticRenderFns }